import React from 'react'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import Spinner from 'srcReact/components/common2/Spinner'

function PendingMessageCount({ count, from, className }) {
  const { t } = useTranslation()

  return count > 0 ? (
    from === 'feed' ? (
      <div className={`${styles.loader} ${className}`}>
        <img
          className={styles.imgLoader}
          alt={t('global.pendingPostCount', { count })}
          src={`${config.assetUrl}/images/imageLoaderAnimeMixR.gif`}
        />
        <p className={styles.text}>{t('global.pendingPostCount', { count })}</p>
      </div>
    ) : (
      <div className={`${styles.messageCount} ${className}`}>
        <Spinner customCss={styles.spinner} />
        <p className={styles.text}>
          {from === 'messenger' ? t('global.pendingMessageCount', { count }) : t('global.pendingPostCount', { count })}
        </p>
      </div>
    )
  ) : null
}

export default PendingMessageCount
